var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStartGuide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_start",
    transform: "translate(-1094 -120)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30A2\\u30A4\\u30B3\\u30F3",
    d: "M0,0V0ZM0,0,10.667,5.333,0,10.667Z",
    transform: "translate(1099.745 121.334)",
    fill: "#72383D",
    stroke: "#72383D",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_812",
    "data-name": "\\u9577\\u65B9\\u5F62 812",
    width: 20,
    height: 20,
    transform: "translate(1094 120)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStartGuide);
export default __webpack_public_path__ + "static/media/icon_start_guide.fd3c29449b3709840593db967f801b2a.svg";
export { ForwardRef as ReactComponent };